const PREFERENCES_MODEL_CLASS_NAME = 'Preferences'

const PREFERENCES_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  PUSH_PLAN_START_WORKOUT_DISABLED: 'pushPlanStartWorkoutDisabled',
  NOTIFICATION_MISSED_PLANNED_WORKOUT_DISABLED: 'notificationMissedPlannedWorkoutDisabled',
  NOTIFICATIONS_FOR_NEW_ARTICLES_DISABLED: 'notificationsForNewArticlesDisabled',
  NEW_ARTICLE_NOTIFICATION_DISABLED: 'newArticleNotificationDisabled',
  TRAINING_TIME: 'trainingTime',
  EQUIPMENT_DATA: 'equipmentData',
  PROFILE_ID: 'profileId'
}

const PREFERENCES_MODEL_PRIVATE_KEYS = []

const PREFERENCES_MODEL_SCOPE = {
  /**
   * Only returns the public attributes of a `Settings`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: PREFERENCES_MODEL_PRIVATE_KEYS
    }
  }
}

export {
  PREFERENCES_MODEL_PRIVATE_KEYS,
  PREFERENCES_MODEL_KEY,
  PREFERENCES_MODEL_CLASS_NAME,
  PREFERENCES_MODEL_SCOPE
}
